import { render, staticRenderFns } from "./approvalItemAdd.vue?vue&type=template&id=0b0436df&scoped=true&"
import script from "./approvalItemAdd.vue?vue&type=script&lang=js&"
export * from "./approvalItemAdd.vue?vue&type=script&lang=js&"
import style0 from "./approvalItemAdd.vue?vue&type=style&index=0&id=0b0436df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0436df",
  null
  
)

export default component.exports